import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Title, Meta } from '@angular/platform-browser';
import { Observable, filter, tap } from 'rxjs';

import { environment } from 'src/environments/environment';
import { NavigationEnd, Router } from '@angular/router';
import { SeoService } from 'src/app/seo.service';

/** Pass untouched request through to the next request handler. */
@Injectable()
export class RequestInterceptor implements HttpInterceptor {
  constructor(private titleService: Title, private meta: Meta,private router: Router) {
      this.router.events.pipe(
        filter(event => event instanceof NavigationEnd)
      ).subscribe((event: any) => {
        const changedUrl = event.url;
        //console.log(event.url);
        this.checkAndUpdateDocumentMeta(changedUrl);
        const changedUrlWithoutFirsSlash = changedUrl.substring(1);
        this.updateCanonicalUrl(changedUrlWithoutFirsSlash);
      
    });
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Clone the request and add the key to the header
    let authKey = '';
    let modifiedRequest!: any
    if(req.url.includes('RegisterForNewBaniReleases')){
      authKey = "Basic " + environment.apiAuthorizationKey;
      modifiedRequest = req.clone({
        setHeaders: {
          "Authorization": authKey,
          "Content-Type": 'application/json',
          "Accept": 'application/json',
        },
      });
    }
    else if(req.url.includes('CreateContactUs')){
      authKey = "Basic " + environment.apiAuthorizationKey;
      modifiedRequest = req.clone({
        setHeaders: {
          "Authorization": authKey,
          "Content-Type": 'application/json',
          "Accept": 'application/json',
        },
      });
    }
    else if(req.url.includes('google')){
      modifiedRequest = req.clone({
        setHeaders: {
          "Content-Type": 'application/json',
          "Accept": 'application/json',
        },
      });
    }
    else{
      modifiedRequest = req.clone({
        setHeaders: {
          'api-key': environment.apiKey,
          "Content-Type": 'application/json',
          "Accept": 'application/json',
        },
      });
    }
   

    // Pass the modified request to the next handler
    // return next.handle(modifiedRequest);
    return next.handle(modifiedRequest).pipe(
      tap((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          //  debugger;
          if (event.status === 200) {
            if (event?.body?.value?.length) {
              let responseArray = event.body.value;
                // console.log("Request Intraceptor Response Array:");
              //console.log(responseArray);
              if(this.router.url === '/' || this.router.url === '/home' || this.router.url === '/search'|| this.router.url === '/glossary'){
                return;
              }
              // any object in the response that contains backend-set
              // values for MetaTagDescription MetaTagKeyWords MetaTagTitle
              // search for anyone of the props
              let seoDataObject = responseArray.find((responseObj: any) => {
                return responseObj.MetaTagTitle || responseObj?.BaniImageURL || responseObj?.MetaTagDescription;
              });
              //console.log("Request Intraceptor Response seoDataObject:");
             // console.log(seoDataObject);
              if (seoDataObject?.MetaTagTitle) {
                this.titleService.setTitle(seoDataObject.MetaTagTitle);
              }

              if(seoDataObject?.BaniImageURL || seoDataObject?.MetaTagTitle){
                 let imageUrl = '';
                if(seoDataObject?.ShowSubSection){
                  const activeSub = req.params?.get('sub');
                  if(activeSub){
                  let activeIndex = seoDataObject.Sections[0]?.SubSection?.findIndex((val:any)=>val.SubSectionSequence == activeSub)
                  if(activeIndex !== -1){
                  imageUrl = seoDataObject?.Sections[0]?.SubSection[activeIndex].ShareImageURL?.trim() ? seoDataObject?.Sections[0]?.SubSection[activeIndex].ShareImageURL 
                             : seoDataObject?.BaniImageURL
                  }
                }
                }
                else{
                  const active = req.params?.get('section');
                  if(active){
                  let activeIndex = seoDataObject.Sections?.findIndex((val:any)=>val.SectionSequence == active);
                  if(activeIndex !== -1){
                  imageUrl = seoDataObject?.Sections[activeIndex]?.ShareImageURL?.trim() ? seoDataObject?.Sections[activeIndex]?.ShareImageURL
                  : seoDataObject?.BaniImageURL
                  };
                }
              }
              imageUrl = imageUrl ? imageUrl : seoDataObject?.BaniImageURL;
                this.addMetaTags(seoDataObject.MetaTagTitle,imageUrl)
              }
             
              if (seoDataObject?.MetaTagDescription) {
                this.meta.updateTag({name: 'description', content: seoDataObject?.MetaTagDescription});
                this.meta.updateTag({property:'og:description', content: seoDataObject?.MetaTagDescription});
                this.meta.updateTag({name: 'twitter:description', content: seoDataObject?.MetaTagDescription});
                
              }
              if (seoDataObject?.MetaTagKeyWords) {
                this.meta.updateTag({name: 'description', content: seoDataObject?.MetaTagDescription});
                this.meta.updateTag({ property:'og:description', content: seoDataObject?.MetaTagKeyWords});
                this.meta.updateTag({name: 'twitter:description', content: seoDataObject?.MetaTagKeyWords});
              }
              // if(this.router.url === '/' || this.router.url === '/home'){
              //   const homeTitle = 'Explore the Guru Granth Sahib in English';
              //   this.titleService.setTitle(homeTitle)
              //   this.meta.updateTag({name: 'title', content: homeTitle});
              //   this.meta.updateTag({property: 'og:title', content: homeTitle});
              //   this.meta.updateTag({name: 'twitter:title', content: homeTitle});
              //   const homeDescription = 'The Guru Granth Sahib Project - a digital resource featuring transliteration, translation, commentary, and calligraphy of the Sikh scripture in English & Punjabi';
              //   this.meta.updateTag({name: 'description', content: homeDescription});
              //   this.meta.updateTag({property:'og:description', content: homeDescription});
              //   this.meta.updateTag({name: 'twitter:description', content: homeDescription});
              // }
            }
          }
        }
      })
      // Errors are handled in the components
      // catchError((error: any) => {
      //   // Handle error responses
      //   console.error('Error occurred', error);
      //   // Perform error handling actions here
      //   throw error;
      // })
    );
  }

  updateCanonicalUrl(url: string) {
   
    const link: HTMLLinkElement | any = document.querySelector('link[rel="canonical"]');
    if(link != undefined && link != null && link != ''){
    const canonicalBaseUrl = link.baseURI;
    link.href = `${canonicalBaseUrl}${url}`;
     //console.log(" link.href" +  link.href);
    }
  }

  checkAndUpdateDocumentMeta(currentUrl: string): void {
    const urlsToCheck = ['/', '/home', '/search', '/team','/contact-us',
      '/approach','/methodology','/glossary','/navigation','/bibliography',
      '/content-citation','/corrections','/privacy-policy','/copyright','/terms-of-use','/project','/guru-granth-sahib'
    ];
    for (const url of urlsToCheck) {
      // console.log(`/${this.getLastUrlSegment(currentUrl)}`)
      if (`/${this.getLastUrlSegment(currentUrl)}` == url) {
          this.updateDocumentMeta(url);
          break; // Exit the loop after finding a match
      }
    }
  }

  getLastUrlSegment(routerUrl: string): string {
    // Split the URL path by the forward slash (/) delimiter
    const urlSegments = routerUrl.split('/');  
    // Handle edge cases: empty URL or URL with only a single slash
    if (urlSegments.length === 0 || urlSegments.length === 1 && urlSegments[0] === '') {
      return ''; // Return empty string for invalid URLs
    }  
    // Return the last element of the URL segments array (last segment)
    return urlSegments[urlSegments.length - 1];
  }

  updateDocumentMeta(routerUrl: string): void {
    let pageTitle = '', pageDescription = '';
    switch (routerUrl) {
      case '/':
      case '/home':
          pageTitle = 'The Guru Granth Sahib in English | Sikh Scripture, Research, History';
          pageDescription = 'The Guru Granth Sahib Project -  featuring transliteration, translation, commentary, and calligraphy of the Sikh scripture in English & Punjabi';
          break;
      case '/project':
          pageTitle = 'Explore The Guru Granth Sahib in English | Sikh Scripture, Research, History';
          pageDescription = 'The Guru Granth Sahib Project- A Global Translation and Transcreation Initiative';
          break;
      case '/search':
          pageTitle = 'Search - Guru Granth Sahib in English';
          pageDescription = 'Search by author, page number, Sabad title, Keyword, Tags.';
          break;
      case '/team':
          pageTitle = 'Teams - Guru Granth Sahib in English';
          pageDescription = 'Since the inception of the project in October 2018, over 127 individuals have been contacted for work, review, and consultation. 18 of these are part of the team, another 42 are engaged in varying capacities';
          break;
      case '/contact-us':
          pageTitle = 'Contact Us - Guru Granth Sahib in English';
          pageDescription = `We'd love to hear from you. Please let us know what you would like to discuss and we'll have the appropriate team member contact you right away.`;
          break;
      case '/approach':
          pageTitle = 'Approach - Guru Granth Sahib in English';
          pageDescription = `The Guru Granth Sahib Project. Accessing Sabad for Today and Tomorrow`;
          break;
      case '/methodology':
          pageTitle = 'Methodology - Guru Granth Sahib in English';
          pageDescription = `Though a plethora of translations created by esteemed early twentieth-century Sikh scholars are available in Panjabi, as well as more recent English translations, there is renewed interest in methods to illuminate the panorama and magnitude within the Guru Granth Sahib`;
          break;
      case '/glossary':
          pageTitle = 'Glossary - Guru Granth Sahib in English';
          pageDescription = `Explaining or defining difficult or unusual words and expressions used in the text.`;
          break;
      case '/navigation':
          pageTitle = 'Navigation - Guru Granth Sahib in English';
          pageDescription = `To make your journey through this repository seamless, here's a quick tutorial and guide.`;
          break;
      case '/bibliography':
          pageTitle = 'Bibliography - Guru Granth Sahib in English';
          pageDescription = `List often with descriptive or critical notes of writings relating to a particular subject, period, or author.`;
          break;
      case '/content-citation':
          pageTitle = 'Citation Guide - Guru Granth Sahib in English';
          pageDescription = `Explaining or defining difficult or unusual words and expressions used in the text.`;
          break;
      case '/corrections':
          pageTitle = 'Corrections - Guru Granth Sahib in English';
          pageDescription = `To make your journey through this repository seamless, here's a quick tutorial and guide.`;
          break;
      case '/privacy-policy':
          pageTitle = 'Privacy Policy - Guru Granth Sahib in English';
          pageDescription = `The Guru Granth Sahib Project (“TGGSP” or "Company" or "we" or “us”) respects your privacy and is committed to protecting it through its compliance with this policy.`;
          break;
      case '/copyright':
          pageTitle = 'Copyright - Guru Granth Sahib in English';
          pageDescription = `All content published on this website, including but not limited to literal translation, interpretive transcreation, commentaries, and other scholarly materials, is protected by US copyright laws and is the intellectual property of The Guru Granth Sahib Project.`;
          break;
      case '/terms-of-use':
          pageTitle = 'Terms of Use - Guru Granth Sahib in English';
          pageDescription = `We provide these Terms of Service for The Guru Granth Sahib Project website (collectively the "Service") so that you know what terms apply to your use. You acknowledge that we have allowed you to review these Terms of Service and that you have agreed to them.`;
          break;
      case '/guru-granth-sahib':
          pageTitle = 'What Is The Guru Granth Sahib all about';
          pageDescription = `The Guru Granth Sahib is the eternal Guru and the supreme guiding authority for Sikhs.`;
          break;
      default:
        break;
    }
    this.titleService.setTitle(pageTitle);
    this.meta.updateTag({ name: 'description', content: pageDescription });
    this.meta.updateTag({ name: 'twitter:title', content: pageTitle });
    this.meta.updateTag({ name: 'twitter:description', content: pageDescription });
    this.meta.updateTag({ property: 'og:title', content: pageTitle });
    this.meta.updateTag({ property: 'og:description', content: pageDescription });
  } 

  addMetaTags(title:string,imageUrl:string){
    //console.log(imageUrl)
    this.meta.updateTag({name: 'title', content: title});

    this.meta.updateTag({property: 'og:title', content: title});
    this.meta.updateTag({property: 'og:description', content: title});
    this.meta.updateTag({property: 'og:image', content: imageUrl});
    this.meta.updateTag({property: 'og:image:type', content: 'image/png'});
    this.meta.updateTag({property: 'og:image:width', content: '1280'});
    this.meta.updateTag({property: 'og:image:height', content: '640'});
    this.meta.updateTag({property: 'og:image:alt', content: title});
    this.meta.addTag({property: 'og:type', content:'website'});

    this.meta.updateTag({name: 'twitter:title', content: title});
    this.meta.updateTag({name: 'twitter:description', content: title});
    this.meta.updateTag({name: 'twitter:image', content: imageUrl});
    this.meta.addTag({name: 'twitter:image:alt', content: title});

  }


}

